// extracted by mini-css-extract-plugin
export default {"gallery":"c-j_gv","gallery__header":"c-j_gw","gallery__thumbs":"c-j_gx"};